import { useSelectedLanguageName } from '@/hooks/useSelectedLanguageName'
import { AnswerType } from '@app-studio-web/ui/types'
import QuizChoicePage from './QuizChoicePage'

const answers: AnswerType[] = [
  {
    emoji: '✈️',
    title: 'pages.quizOnboarding.importantEvent.answer1',
    value: 'travel',
  },
  {
    emoji: '👨‍👩‍👧',
    title: 'pages.quizOnboarding.importantEvent.answer2',
    value: 'family_visit',
  },
  {
    emoji: '💼',
    title: 'pages.quizOnboarding.importantEvent.answer3',
    value: 'job_interview',
  },
  {
    emoji: '🌍',
    title: 'pages.quizOnboarding.importantEvent.answer4',
    value: 'moving_abroad',
  },
  {
    emoji: '❤️',
    title: 'pages.quizOnboarding.importantEvent.answer5',
    value: 'relationship',
  },
  {
    emoji: '🙂',
    title: 'pages.quizOnboarding.importantEvent.answer6',
    value: 'none',
  },
]

export default function ImportantEventPage() {
  const language = useSelectedLanguageName()

  return (
    <QuizChoicePage
      answers={answers}
      subtitle="pages.quizOnboarding.importantEvent.subtitle"
      title="pages.quizOnboarding.importantEvent.title"
      translationInterpolation={{ language }}
    />
  )
}
